import React, { useState } from 'react'

import Form_component from '../../contact_us/contact_form/Form_component';

function Enquire_from() {



    return (
        <>
            <section className="Contact_Form">
                <div className="form_div">
                    <h2 className="Enquiry_section_enquiry_title">Enquiry</h2>
                    <Form_component />
                </div>
            </section>
        </>
    )
}

export default Enquire_from